
import React, { useMemo } from "react";
import  { useState, useEffect } from "react";


function Pagination({ page, setPage, info }) {


useEffect(() => {
  if (info?.totalPages && page > info?.totalPages) {
    setPage(info?.totalPages); // Adjust to the last page if out of bounds
  }
}, [info?.totalPages, page]);

  const totalPages = info?.totalPages;

  const pageNumbers = useMemo(() => {
    const maxDisplay = 5; 
    const pageNumbers = [];

    if (info?.totalPages <= maxDisplay) {
      for (let i = 1; i <= info?.totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (page <= 3) {
        pageNumbers.push(1, 2, 3, 4, "...", info?.totalPages);
      } else if (page >= totalPages - 2) {
        pageNumbers.push(1, "...", info?.totalPages - 3, info?.totalPages - 2, info?.totalPages - 1, info.totalPages);
      } else {
        pageNumbers.push(1, "...", page - 1, page, page + 1, "...", info?.totalPages);
      }
    }

    return pageNumbers;
  }, [page, info?.totalPages]);

  return (
    <div className="flex justify-center mt-4">
      <button
        className={`bg-white px-3 py-2 rounded-lg ${
          page === 1 ? "text-gray-400 cursor-not-allowed" : "text-[#258CFB]"
        }`}
        onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
        disabled={page === 1}
        aria-label="Previous Page"
      >
        Prev.
      </button>
      {pageNumbers.map((pg, index) =>
        pg === "..." ? (
          <span key={`ellipsis-${index}`} className="px-3 py-2 text-gray-500">
            ...
          </span>
        ) : (
          <button
            key={`page-${pg}`}
            className={`px-2 ${
              pg === page ? "bg-[#258CFB] text-sm text-white rounded-full m-1" : "text-sm text-[#737373]"
            }`}
            onClick={() => setPage(pg)}
          >
            {pg}
          </button>
        )
      )}
      <button
        className={`bg-white px-3 py-2 rounded-lg ${
          page === totalPages ? "text-gray-400 cursor-not-allowed" : "text-[#258CFB]"
        }`}
        onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
        disabled={page === totalPages}
        aria-label="Next Page"
      >
        Next
      </button>
    </div>
  );
}

export default Pagination;